var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"signStatus"},[_c('img',{attrs:{"src":_vm.img,"alt":""},on:{"click":_vm.toSign}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }